import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { taggedStoreUrl } from '../../utils/trackStoreClicks';
import { WEB_APP_URL } from '../../utils/webApp';
import './GetAppPage.css';

const APP_STORE_URL = 'https://apps.apple.com/app/id6747190886';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.voia.travel.mobile';

// iPadOS reports itself as a Mac, so a touch-capable "Mac" counts as iOS.
function phoneStore() {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'app_store';
  if (/Android/.test(ua)) return 'google_play';
  return null;
}

/**
 * What the "Get the app" QR code opens (GET_APP_URL in src/utils/webApp.js). A
 * phone goes straight to its store, counted as a store_click from the QR code;
 * anything else sees both badges and the web app.
 */
const GetAppPage = () => {
  useEffect(() => {
    const store = phoneStore();
    if (!store) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'store_click', {
        store,
        link_location: 'qr',
        page_path: '/get',
        entry_source: 'qr',
        transport_type: 'beacon',
      });
    }
    window.location.replace(taggedStoreUrl(store, { campaign: 'get-app', medium: 'qr', content: 'qr' }));
  }, []);

  return (
    <div className="getAppPage">
      <Navbar />
      <main className="getAppPageMain">
        <h1>Get VOIA</h1>
        <p>Free on iOS and Android.</p>
        <div className="getAppPageStores">
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img src="/assets/app_store_badge.svg" alt="Download VOIA on the App Store" />
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img src="/assets/google_play_badge.png" alt="Get VOIA on Google Play" />
          </a>
        </div>
        <p className="getAppPageWeb">
          On a laptop? <a href={WEB_APP_URL}>Plan your trips on the web</a>
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default GetAppPage;
